import React from 'react';
import { Box } from '@material-ui/core';
import { NavLink } from 'react-router-dom';
import CmtImage from '../../../../@coremat/CmtImage';
import makeStyles from '@material-ui/core/styles/makeStyles';

const useStyles = makeStyles({
  logo: {
    maxHeight: 40,
    width: 'auto',
    objectFit: 'contain',
  },
});

const FooterLogo = ({ color, ...props }) => {
  const classes = useStyles();
  const logoUrl = color === 'white' ? '/images/logo-white.png' : '/images/logo.png';

  return (
    <Box className="pointer" {...props}>
      <NavLink to="/">
        <CmtImage src={logoUrl} alt="Shimanto Bank" className={classes.logo} />
      </NavLink>
    </Box>
  );
};

export default FooterLogo;
